import React from 'react'
import clsx from 'clsx'
import iconsSet from './config'
import * as PropTypes from 'prop-types'

const CreateNetworkIcon = ({
  iconsSet,
  name,
  className,
  type = '',
  width = null,
  height = null,
}) => {
  const props = {}

  if (!iconsSet[name]) {
    return <span>NoIcon: {name}</span>
  }

  if (width || height) {
    props.width = width || 'auto'
    props.height = height || 'auto'
  }

  const Component = iconsSet[name][type]
    ? iconsSet[name][type]
    : iconsSet[name]['component']

  return (
    <Component
      className={clsx('network-logo', className, ['' + type])}
      {...props}
    />
  )
}

CreateNetworkIcon.propTypes = {
  iconsSet: PropTypes.object,
  height: PropTypes.number,
  type: PropTypes.oneOf(['default', 'unlinked', 'inner']),
  className: PropTypes.string,
  width: PropTypes.number,
  name: PropTypes.string,
}

const NetworkIcon = (args) => CreateNetworkIcon({ ...args, iconsSet })

export default NetworkIcon
